import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { DependencyLicenseListFacade } from './dependency-license-list.facade';

@Injectable({
  providedIn: 'root',
})
export class DependencyLicenseListGuard {
  constructor(private dependencyLicenseListFacade: DependencyLicenseListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return checkStoreState(this.dependencyLicenseListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.dependencyLicenseListFacade);
  }
}
